var _styled, _styled2;

// https://github.com/alphagov/govuk-frontend/tree/master/src/components/panel
import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { TURQUOISE, WHITE } from 'govuk-colours';
import { withWhiteSpace } from '@govuk-react/hoc';
import { MEDIA_QUERIES, NTA_LIGHT, SPACING } from '@govuk-react/constants';
var StyledPanel = styled('div')({
  backgroundColor: TURQUOISE,
  color: WHITE,
  padding: SPACING.SCALE_5
}); // TODO use standard font constants

var StyledTitle = styled('h2')((_styled = {
  fontFamily: NTA_LIGHT,
  fontWeight: 'bold',
  WebkitFontSmoothing: 'antialiased',
  fontSize: '32px',
  lineHeight: '35px',
  marginTop: 0,
  textAlign: 'center'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: '48px',
  lineHeight: '50px'
}, _styled)); // TODO use standard font constants

var StyledBody = styled('div')((_styled2 = {
  fontFamily: NTA_LIGHT,
  fontSize: '24px',
  fontWeight: 400,
  lineHeight: '25px',
  marginTop: SPACING.SCALE_3,
  marginBottom: SPACING.SCALE_2,
  textAlign: 'center',
  WebkitFontSmoothing: 'antialiased'
}, _styled2[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: '36px',
  lineHeight: '40px'
}, _styled2));

var Panel = function Panel(_ref) {
  var panelTitle = _ref.panelTitle,
      panelBody = _ref.panelBody,
      className = _ref.className;
  return React.createElement(StyledPanel, {
    className: className
  }, React.createElement(StyledTitle, null, panelTitle), React.createElement(StyledBody, null, panelBody));
};

Panel.defaultProps = {
  panelBody: undefined,
  className: undefined
};
Panel.propTypes = process.env.NODE_ENV !== "production" ? {
  panelTitle: PropTypes.string.isRequired,
  panelBody: PropTypes.string,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 3
})(Panel);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/panel/es/index.js
// module id = 88
// module chunks = 0